<!-- Top bar -->
<mat-toolbar class="topBar" style="justify-content: space-between;">

  <!-- Back to Current Delivery -->
  <button mat-mini-fab
          class="icon-button"
          aria-label="Example icon-button with menu icon"
          [matTooltip]="title == 'All sets' ? 'Back to Menu' : title.includes('Logbook') ? 'Back to Delivery' : title.includes('Groundfish') ? 'Back to Current Groundfish Delivery' : title.includes('HMS') ? 'Back to Current HMS Delivery' : 'Go Back'"
          matTooltipPosition="above"
          (click)="navigateBack()">
    <mat-icon>
      arrow_back
    </mat-icon>
  </button>
  <span style="flex-grow: 1"> Summary - {{title}}</span>

  <button mat-mini-fab 
         class="icon-button"
          (click)="router.navigate(['summary_report_ytd'])">
    <mat-icon>event</mat-icon>
  </button>

</mat-toolbar>

<div class="container" style="max-width: none;">
  <div class="row">
    <table mat-table [dataSource]="computedCatch()">

      <!-- Species Name Column -->
      <ng-container matColumnDef="Species">
        <th mat-header-cell *matHeaderCellDef> Species </th>
        <td mat-cell *matCellDef="let item"> {{item.species.name}} </td>
      </ng-container>

      <!-- Retained Count Column -->
      <ng-container matColumnDef="RetainedCount">
        <th mat-header-cell *matHeaderCellDef> Count - Retained </th>
        <td mat-cell *matCellDef="let item"> {{item.retainedCount ?? '-'}} </td>
      </ng-container>

      <!-- Retained Weight Column -->
      <!-- HMS enters an average weight per fish, so this column is the count-weighted total -->
      <ng-container matColumnDef="RetainedWeight">
        <th mat-header-cell *matHeaderCellDef> {{catchFishery === 'HMS' ? 'Total Weight (lbs)' : 'Weight'}} - Retained </th>
        <td mat-cell *matCellDef="let item">
          {{(item.retainedWeight | number) ?? '-'}}
        </td>
      </ng-container>

      <!-- Released Count Column -->
      <ng-container matColumnDef="ReleasedCount">
        <th mat-header-cell *matHeaderCellDef> Count - Released </th>
        <td mat-cell *matCellDef="let item"> {{item.releasedCount ?? '-'}} </td>
      </ng-container>

      <!-- Released Weight Column -->
      <ng-container matColumnDef="ReleasedWeight">
        <th mat-header-cell *matHeaderCellDef> {{catchFishery === 'HMS' ? 'Total Weight (lbs)' : 'Weight'}} - Released </th>
        <td mat-cell *matCellDef="let item">
          {{(item.releasedWeight | number) ?? '-'}}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="catchTableColumns" class="second-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: catchTableColumns; let index=index;"></tr>

    </table>
  </div>
</div>
